export const environment = {
  production: false,
  errMsg: 'Failed to complete. Please try again.',
  partner: false,
  config: {
    stage: 'dev',
    appName: 'chat-bot-webapp',
    partnerName: '75F',
    chatSupportUrl: 'https://support.75f.io/hc/en-us/articles/22524392931603-Saffron-AI-Chat-Bot',
    multiRegion: false,
    defaultRegion: '1',
    preConfigUrl: "https://site-preconfig-api.dev.service.75f.io",
    regionsList: ['1'],
    '1': {
      regionCode: 'NA',
      regionName: 'North America',
      chatServiceUrl: 'https://chat.dev.service.75f.io'
    }
  }
};
